var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48263 6.00589C6.48263 3.7869 8.28149 1.98804 10.5004 1.98804C12.7194 1.98804 14.5183 3.7869 14.5183 6.00589V9.62197C14.5183 11.8409 12.7194 13.6398 10.5004 13.6398C8.28149 13.6398 6.48263 11.8409 6.48263 9.62197V6.00589Z",
    fill: "url(#paint0_linear_3066_11334)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52814 11.7918C5.39488 11.4868 5.03959 11.3475 4.73458 11.4808C4.42957 11.6141 4.29035 11.9694 4.42361 12.2744C5.36967 14.4397 7.44007 16.0032 9.89848 16.2248V17.4571C9.89848 17.7901 10.1683 18.0598 10.5012 18.0598C10.834 18.0598 11.1038 17.7901 11.1038 17.4571V16.2248C13.5623 16.0032 15.6327 14.4397 16.5787 12.2744C16.712 11.9694 16.5728 11.6141 16.2677 11.4808C15.9628 11.3475 15.6075 11.4868 15.4742 11.7918C14.6367 13.7087 12.7245 15.0464 10.5012 15.0464C8.27788 15.0464 6.36569 13.7087 5.52814 11.7918Z",
    fill: "url(#paint1_linear_3066_11334)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3066_11334",
    x1: 10.5005,
    y1: 1.98804,
    x2: 10.5005,
    y2: 13.6398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3066_11334",
    x1: 10.5012,
    y1: 11.4302,
    x2: 10.5012,
    y2: 18.0598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.74cbdb314973865f7544e71596cec35e.svg";
export { ForwardRef as ReactComponent };